namespace TabAurous.Inventory {
    export namespace RepairItemsService {
        export const baseUrl = 'Repair/RepairItems';

        export declare function Create(request: Serenity.SaveRequest<RepairItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RepairItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RepairItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<RepairItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<RepairItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Repair/RepairItems/Create",
            Update = "Repair/RepairItems/Update",
            Delete = "Repair/RepairItems/Delete",
            Retrieve = "Repair/RepairItems/Retrieve",
            List = "Repair/RepairItems/List",
            CustomList = "Repair/RepairItems/CustomList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList'
        ].forEach(x => {
            (<any>RepairItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
